import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the DateRangeFormatPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'dateRangeFormat',
})
export class DateRangeFormatPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value, inputString) {
    if (value && value.beginDate && value.endDate){
      if (inputString === 'begin'){
        return `${value.beginDate.year}-${value.beginDate.month}-${value.beginDate.day}`;
      } else if (inputString === 'end'){
        return `${value.endDate.year}-${value.endDate.month}-${value.endDate.day}`;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/date-range-format/date-range-format.ts